import React, { useEffect, useState } from 'react';
import { compatApi } from '../utils/Intercepter';
import OpenApiRequest from '../utils/OpenApiRequest';

export default function OrganizationInfoModal({ isOpen, onClose, organizationData }) {
    const [organization, setOrganization] = useState({
        organizationCode: '',
        organizationName: '',
        isApproved: '',
        organizationDomain: '',
        address: '',
        isValidated: false,
        bizRegNo: ''
    });

    // eslint-disable-next-line no-unused-vars
    const [isEditing, setIsEditing] = useState(false);

    useEffect(() => {
        if (isOpen && organizationData?.organizationCode) {
            fetchOrganizationInfo(organizationData.organizationCode);
        }
    }, [isOpen, organizationData]);

    const fetchOrganizationInfo = async (orgCode) => {
        try {
            const response = await compatApi.post(`/org/admin/organizationInfo`, orgCode);
            if (response.ok) {
                setOrganization(response.data);
            } else {
                alert('조직 정보를 가져오는 데 실패했습니다.');
            }
        } catch (error) {
            alert('네트워크 오류가 발생했습니다.');
        }
    };

    // eslint-disable-next-line no-unused-vars
    const handleInputChange = (e) => {
        setOrganization((prev) => ({ ...prev, organizationName: e.target.value }));
    };

    // eslint-disable-next-line no-unused-vars
    const handleSave = async () => {
        try {
            const response = await compatApi.post('/org/update-organization', {
                organizationCode: organization.organizationCode,
                organizationName: organization.organizationName,
            });
            if (response.ok) {
                alert('수정되었습니다.');
                await fetchOrganizationInfo(organization.organizationCode);
            } else {
                alert('수정 실패했습니다.');
            }
        } catch (error) {
            alert('네트워크 오류가 발생했습니다.');
        }
        setIsEditing(false);
    };

    // eslint-disable-next-line no-unused-vars
    const validateBusiness = async () => {
        const businessNumber = organization.organizationCode.replace(/-/g, '');
        try {
            const requestBody = { "b_no": [businessNumber] };
            const statusResponse = await OpenApiRequest.getStatus(requestBody);
            const responseText = await statusResponse.text();
            if (statusResponse.ok) {
                const statusResult = JSON.parse(responseText);
                if (statusResult.data && statusResult.data[0]) {
                    const businessStatus = statusResult.data[0].b_stt;
                    if (!businessStatus || businessStatus === "휴업자" || businessStatus === "폐업자") {
                        alert('유효하지 않은 사업자 등록번호입니다. 다시 확인해주세요.');
                        return;
                    } else {
                        try {
                            const validationResponse = await compatApi.get(`/org/validate/${organization.organizationCode}`);
                            if (validationResponse.ok) {
                                alert('사업자 등록이 성공적으로 인증되었습니다.');
                                await fetchOrganizationInfo(organization.organizationCode);
                            } else {
                                alert('사업자 등록 상태 업데이트에 실패했습니다.');
                            }
                        } catch (error) {
                            alert('사업자 등록 상태 업데이트에 실패했습니다.');
                        }
                    }
                }
            }
        } catch (error) {
            alert('사업자번호 검증 서비스에 연결할 수 없습니다. 잠시 후 다시 시도해주세요.');
        }
    };

    if (!organizationData || !isOpen) return null;

    const thS = { padding: '10px 14px', background: '#f5f4fa', fontWeight: 700, fontSize: 13, color: '#1f1d2e', border: '1px solid #f0eff5', width: '30%' };
    const tdS = { padding: '10px 14px', fontSize: 13, color: '#3a3849', border: '1px solid #f0eff5' };

    return (
        <div onClick={onClose} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1050, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
            <div onClick={(e) => e.stopPropagation()} style={{ background: 'white', borderRadius: 16, width: '100%', maxWidth: 600, boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
                <div style={{ padding: '16px 20px', borderBottom: '1px solid #f0eff5', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontWeight: 700, fontSize: 15, color: '#1f1d2e' }}>조직 정보</span>
                    <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 20, color: '#8b8a99', lineHeight: 1 }}>×</button>
                </div>
                <div style={{ padding: '20px' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <tbody>
                            <tr>
                                <th style={thS}>조직 이름</th>
                                <td style={tdS}>{organization.organizationName}</td>
                            </tr>
                            <tr>
                                <th style={thS}>조직 코드</th>
                                <td style={tdS}>{organization.organizationCode}</td>
                            </tr>
                            <tr>
                                <th style={thS}>사업자 등록 번호</th>
                                <td style={tdS}>{organization.bizRegNo}</td>
                            </tr>
                            <tr>
                                <th style={thS}>관리자 승인</th>
                                <td style={tdS}>
                                    <span style={{ color: organization.isApproved === 'Y' ? 'green' : organization.isApproved === 'N' ? 'orange' : 'red', fontWeight: 'bold' }}>
                                        {organization.isApproved}
                                    </span>
                                    {' '}({organizationData.approvalDate || '미승인'})
                                </td>
                            </tr>
                            <tr>
                                <th style={thS}>주소</th>
                                <td style={tdS}>{organization.address || 'N/A'}</td>
                            </tr>
                            <tr>
                                <th style={thS}>조직 생성일</th>
                                <td style={tdS}>{organizationData.registrationDate || 'N/A'}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div style={{ padding: '12px 20px', borderTop: '1px solid #f0eff5', display: 'flex', justifyContent: 'flex-end' }}>
                    <button onClick={onClose} style={{ height: 36, padding: '0 16px', borderRadius: 8, border: '1.5px solid #d1d5db', background: 'white', color: '#6b7280', fontWeight: 600, fontSize: 14, cursor: 'pointer', fontFamily: 'inherit' }}>닫기</button>
                </div>
            </div>
        </div>
    );
}
